<template>
  <v-app id="iosper-app"
   :style="{background: $vuetify.theme.themes['dark'].background}">
    <v-navigation-drawer
      v-model="drawer"
      color="warning"
      app
    >
      <template v-slot:prepend>
        <v-list-item two-line>
          <v-list-item-avatar>
            <img src="https://randomuser.me/api/portraits/women/81.jpg">
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>Carolina Gutierrez</v-list-item-title>
            <v-list-item-subtitle>Conectado</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>

      <v-divider></v-divider>
      <v-list dense>
        <v-list-item v-for="item in items" :key="item.text" :to="item.path">
          <v-list-item-action>
            <v-icon>mdi-{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      dark
      color="warning"
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Prescripción electrónica</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-img
        alt="IOSPER"
        class="shrink mx-auto"
        contain
        src="@/assets/logo.png"
        transition="fade-transition"
        width="40"
      />
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>

    <v-snackbar
      v-model="showSnackbar"
      :timeout="7000"
    >
      {{ snackbarMessage }}
      <v-btn
        color="warning"
        text
        @click="snackbar = false"
      >
        Close
      </v-btn>
    </v-snackbar>
    <v-footer
      app inset padless
      transition="fade-transition"
    >
      <v-col
        class="text-center ma-0 pa-0"
        cols="6"
      >
        <v-img
          src="@/assets/iosper.svg"
          aspect-ratio="12" contain
         >
        </v-img>
      </v-col>
      <v-col
        class="text-center ma-0 pa-0"
        cols="6"
      >
        &copy; {{ new Date().getFullYear() }}
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex"
import store from '@/store'

export default {
  name: 'App',

  data: () => ({
    drawer: false,
    showSnackbar: false,
    items: [
      {
        icon: 'home',
        title: 'Inicio',
        path: '/home',
        items: [],
      },
      {
        icon: 'grease-pencil',
        title: 'Prescripbir',
        path: '/prescribir',
        items: []
      },
      {
        icon: 'playlist-check',
        title: 'Ver prescripciones',
        path: '/prescripciones',
        items: []
      },   
      {
        icon: 'exit-to-app',
        title: 'Salir',
        path: '/salir',
        items: []
      },       
    ]
  }),
  
  watch: {
    showSnackbar: function(newVal) {
      if (!newVal) store.dispatch("setError", '')
    },
    snackbarMessage: function(newVal) {
      if (newVal) this.showSnackbar = true
    },
  },

  computed: {
    ...mapGetters({
      snackbarMessage: "error"
    })
  },
};
</script>

<style>
/* Change the white to any color ;) */
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active  {
    -webkit-box-shadow: 0 0 0 30px #005A55 inset !important;
}
input:-webkit-autofill {
    -webkit-text-fill-color: #E1D7C4 !important;
}
</style>